import React from 'react'

const AboutDetails = () => {
  return (
    <>
        <div className="mb-11 container mx-auto font-avenir">
                <div className="grid md:grid-cols-2 gap-10 pb-11 px-10">
                    <div className="flex md:text-start text-lg flex-col gap-3 md:pl-7 md:pr-10 pt-10 mt-6">
                        <h2 className="md:text-[40px] text-4xl -mb-1  font-semibold">
                            About ClevDoc
                        </h2>
                        <h2 className="text-l font-semibold md:text-justify drop-shadow-lg shadow-black">
                            Digital infrastructure for institutions that still run on paper.
                        </h2>
                        <p className="text-justify tracking-wide">
                            We're a Gurugram-based SaaS company. Our Banking Communication Platform digitizes how banks reach borrowers, and our Virtual Arbitration Platform brings case management for arbitration online. Both replace manual, paper-based processes with something verifiable and reliable.
                        </p>
                        <ol className='list-decimal md:ml-14 ml-7 text-justify'>
                            <li>No need for a large in-house IT team to get started.</li>
                            <li>We build focused products for specific problems, not one broad platform trying to do everything.</li>
                            <li>Built specifically for how institutions in India operate day to day.</li>
                        </ol>
                        <p className="text-justify">
                            We believe in India’s Digital Revolution journey to develop for a better tomorrow across different societies, economies, and above all humanity.
                        </p>
                    </div>
                    <div className="grid place-items-center">
                        <div className=" px-5 py-2 md:pt-24 ">
                            <div className="-m-1 flex flex-wrap md:-m-2">
                               <img src="https://cdn.clevdoc.com/uploads//blog/images/WhatsApp+Image+2026-08-11+at+4.04.05+PM.jpeg"  alt="Not available" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </> 
  )
}

export default AboutDetails